<template>
  <sys-data-table
    v-model="itens_selecionados"
    :headers="headers"
    :items="desserts"
    :item-height="45"
    :height="alturaDaJanela - 420"
    hide-default-footer
  >
    <template #item.tipo="{ value }">
      {{ value === 'A' ? 'ITEM' : 'SIMILAR' }}
    </template>

    <template #item.preco_atual="{ value }">
     {{ value ? 'R$ ' + Helpers.formatarValorComCasas(value, 4) : '-' }}
    </template>

    <template #item.ultimo_preco="{ value }">
     {{ value ? 'R$ ' + Helpers.formatarValorComCasas(value, 4) : '-' }}
    </template>

    <template #item.penultimo_preco="{ value }">
     {{ value ? 'R$ ' + Helpers.formatarValorComCasas(value, 4) : '-' }}
    </template>
  </sys-data-table>
</template>

<script>
import Responsividade from "@/helpers/ResponsiveHeight";
import { headers_default } from "./exports";

export default {
  name: 'TebelaComparativoPreco',
  mixins: [Responsividade],
  props: {
    itens: {
      type: Array
    },
    produto: Object,
  },
  watch: {
    itens(valor) {
      this.desserts = valor;
    }
  },
  data() {
    return {
      headers: headers_default,
      desserts: [],
      itens_selecionados: [],
    };
  },
}
</script>

<style>

</style>
